import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { getCaseCategoryByCaseType } from "../../../../utils";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getPolicyDetailById,
  getPolicyWithdrawalDetailById,
  getPolicyWithdrawalsListItems,
} from "../../../../redux/Case/policySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function PolicyWithdrawals({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const policies = useSelector((state: RootState) => state.policies);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const [caseType, setCaseType] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
      dispatch(
        getPolicyWithdrawalsListItems({ id: caseId, customerId: clientId })
      );
    }
  }, [caseId, clientId, dispatch]);

  useEffect(() => {
    if (policies?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(policies.activeItem.case_type));
    }
  }, [policies?.activeItem]);

  const withdrawalId =
    subItemId || policies.withdrawals.listItems[0]?.withdrawal_id;
  useEffect(() => {
    if (!caseId || !withdrawalId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/withdrawals/${withdrawalId}/withdrawal/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/policies/${caseId}/withdrawal/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/withdrawals/${withdrawalId}/withdrawal/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/policies/${caseId}/withdrawals/${withdrawalId}/withdrawal/view`
      );
    }
  }, [
    clientId,
    action,
    caseId,
    policies.withdrawals.listItems,
    withdrawalId,
    navigate,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getPolicyWithdrawalDetailById(subItemId));
    }
  }, [subItemId, dispatch, policies.withdrawals.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="withdrawals"
        section="policies"
        tab={tab}
        caseType={caseType}
        caseDetail={policies?.withdrawals.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="policies"
          caseType={caseType}
          caseDetail={policies?.withdrawals.activeItem}
          caseItemList={policies?.withdrawals.listItems}
          tab={tab}
          subItem="withdrawals"
          withdrawalValue={policies.withdrawals.totalWithdrawals}
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {policies?.withdrawals.listLoading ? (
            <ContentLoader />
          ) : (
            <>
              {policies?.withdrawals.listItems.length > 0 && (
                <CaseList
                  module="withdrawals"
                  data={policies?.withdrawals.listItems}
                  activeItem={policies?.withdrawals.activeItem}
                  section="policies"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && policies?.withdrawals.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={policies?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default PolicyWithdrawals;
